import type { QueryClient } from '@tanstack/react-query';

import type { ObjectResponse } from '@verantos-dev/types-common';

import { analysisKeys } from './queryKeys';
import type { AnalysisProfile } from './types';

/**
 * Write `latestStatus: 'PROCESSING'` onto the cached analysis profile right
 * after a run is dispatched (by the Process button or the RA's process_analysis
 * tool). A refetch at that moment can cache a stale pre-PROCESSING snapshot
 * that never resumes the profile query's PROCESSING poll, so callers write the
 * status directly instead of invalidating the profile.
 */
export const markAnalysisProcessing = (queryClient: QueryClient, analysisProfileId: string) => {
  queryClient.setQueryData<ObjectResponse<AnalysisProfile>>(
    analysisKeys.profile(analysisProfileId),
    (prev) => (prev ? { ...prev, data: { ...prev.data, latestStatus: 'PROCESSING' } } : prev)
  );
};
